var _excluded = ["children", "className", "disableAnimation", "domRef"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { classnames } from '@okee-uikit/react-utils';
import { useChildrenEnterLeave } from '../../hooks/animation';
import React, { useEffect, useLayoutEffect } from 'react';
import { usePrefixCls } from '@okee-uikit/react-config';
import { Tag } from './Tag';
var Effect = typeof window === 'undefined' ? useEffect : useLayoutEffect;
export function Group(props) {
  var children = props.children,
      className = props.className,
      disableAnimation = props.disableAnimation,
      domRef = props.domRef,
      extra = _objectWithoutProperties(props, _excluded);

  var cls = classnames(usePrefixCls('tag-group'), className);

  var _useChildrenEnterLeav = useChildrenEnterLeave(children, {
    duration: 200,
    ignoreInitialRender: true,
    disabled: disableAnimation,
    childRefKey: getChildRefKey,
    enterTick: frameAnimationEnterTick
  }),
      _useChildrenEnterLeav2 = _slicedToArray(_useChildrenEnterLeav, 2),
      animatedChildren = _useChildrenEnterLeav2[0],
      startAnimation = _useChildrenEnterLeav2[1];

  Effect(startAnimation);
  return React.createElement("div", _objectSpread(_objectSpread({}, extra), {}, {
    className: cls,
    ref: domRef
  }), animatedChildren);
}

function getChildRefKey(element) {
  return element.type === Tag ? 'domRef' : typeof element.type === 'string' ? 'ref' : null;
}

function frameAnimationEnterTick(domNode, percent, memo) {
  if (percent >= 1) {
    domNode.style.removeProperty('opacity');
    domNode.style.removeProperty('transition');
    domNode.style.removeProperty('margin-left');
    return memo;
  }

  var width = memo || domNode.getBoundingClientRect().width;

  if (!domNode.style.getPropertyValue('transition')) {
    domNode.style.setProperty('transition', 'none');
  }

  domNode.style.setProperty('opacity', "".concat(percent));
  domNode.style.setProperty('margin-left', "".concat(width * (percent - 1), "px"));
  return width;
}